export const deliveryCompleteFlg = {
  BEFORE_DELIVERY: 0,
  AFTER_DELIVERY: 1,
} as const;
